import styled from 'styled-components';

export const Card = styled.button<{ $isSelected: boolean }>`
  display: flex;
  align-items: stretch;
  min-width: 0;
  flex-shrink: 0;
  width: 100%;
  max-width: 213px;
  min-height: 80px;
  border-radius: 8px;
  border: none;
  background: ${(props) => (props.$isSelected ? props.theme.colors.main_cta : props.theme.colors.widget_background)};
  box-sizing: border-box;
  overflow: hidden;
  cursor: pointer;
  padding: 0;
  text-align: left;

  &:hover {
    background: ${(props) => (props.$isSelected ? props.theme.colors.main_cta : props.theme.colors.widget_hover_background)};
  }
  &:focus {
    outline: none;
  }

  @media (min-width: 400px) {
    max-height: 104px;
    width: 213px;
  }
`;

export const Main = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 10px 12px 14px;

  @media (min-width: 400px) {
    padding: 12px;
    gap: 6px;
  }
`;

export const TopRow = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const PlayButton = styled.button<{ $isSelected: boolean }>`
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  min-width: 34px;
  min-height: 34px;
  border-radius: 4px;
  border: none;
  background: ${(props) => (props.$isSelected ? props.theme.colors.black : props.theme.colors.outline)};
  color: ${(props) => (props.$isSelected ? props.theme.colors.white : props.theme.colors.white)};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  &:hover {
    background: ${(props) => (props.$isSelected ? props.theme.colors.black : '#6B6B6B')};
  }
  &:focus {
    outline: none;
  }
`;

export const Content = styled.div`
  min-width: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-left: 0;
  overflow: hidden;
`;

export const FileName = styled.span<{ $isSelected: boolean }>`
  font-size: 13px;
  line-height: 1.35;
  color: ${(props) => (props.$isSelected ? props.theme.colors.black : props.theme.colors.text)};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Meta = styled.span<{ $isSelected: boolean }>`
  font-size: 12px;
  line-height: 1.35;
  color: ${(props) => (props.$isSelected ? props.theme.colors.black : props.theme.colors.inactive)};
`;

export default {
  Card,
  Main,
  TopRow,
  PlayButton,
  Content,
  FileName,
  Meta,
};
